import type { PipeTransform } from '@angular/core';
import { Injectable, Pipe } from '@angular/core';

@Pipe({
  name: 'boldText',
  standalone: true,
})
@Injectable({
  providedIn: 'root',
})
export class BoldTextPipe implements PipeTransform {
  public transform(text: string, ...args: any[]): string {
    return text?.length > 0 ? `<b>${text}</b>` : text;
  }
}
